<template>
  <div class="progress"
    :style="{ width: progress + '%' }"
  >
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: Number
  }
}
</script>

<style scoped>
.progress {
  background-color: #edebed;
  height: 32px;
  box-shadow: 2px 2px 6px #fff;
}
</style>
